import { Container, DefaultPageLayout } from 'routes/components/Layout'
import { LINKS } from 'routes/constants'
import { BreadcrumbsNavigation } from 'routes/components/Shared'
import { BestSupport } from 'routes/components/Features/BestSupport'
import {
  ConnectorsStatsType,
  getSolutionsBreadcrumbs,
  PageType,
} from 'routes/Solutions/helpers'
import { SolutionHeadMetatag } from 'routes/Solutions/components/SolutionHeadMetatag'
import { SolutionSection } from 'routes/Solutions/components/SolutionSection'
import { SolutionNetwork } from 'routes/Solutions/components/SolutionNetwork'
import { SolutionRequest } from 'routes/Solutions/components/SolutionRequest'
import { SolutionAI } from 'routes/Solutions/components/SolutionAI'
import { SolutionCompanies } from 'routes/Solutions/components/SolutionCompanies'
import { SolutionInfrastructure } from 'routes/Solutions/components/SolutionInfrastructure'
import { DataIntegrationToolsHero } from './components/Hero'
import { DataIntegrationFrameWork } from './components/Framework'
import pageCoverImage from './components/Hero/hero-mob.avif'
import classes from '../solutions.module.scss'

export const pageData: PageType = {
  title: 'Solutions for Data Integration Tools',
  href: LINKS.SOLUTIONS.DATA_INTEGRATION_PLATFORMS,
  imageSrc: `${pageCoverImage.src}`,
  description:
    'Scale your connector library at a fraction of the cost. Accelerate your integration roadmap by years.',
}

export default function DataIntegrationToolsPage({
  stats,
}: {
  stats: ConnectorsStatsType
}) {
  const breadcrumbs = getSolutionsBreadcrumbs(pageData.title)

  return (
    <DefaultPageLayout className={classes.page}>
      <SolutionHeadMetatag pageData={pageData} />
      <Container>
        <BreadcrumbsNavigation
          breadcrumbs={breadcrumbs}
          className={classes.breadcrumbs}
        />
      </Container>
      <Container grid>
        <DataIntegrationToolsHero />
        <SolutionSection>
          <SolutionNetwork stats={stats} />
          <DataIntegrationFrameWork />
        </SolutionSection>
        <SolutionRequest />
        <SolutionAI
          title='Scale your connector library with Al'
          text='Our open connector framework allows you to consistently access data and
        metadata across every API. Building connectors is often slow and
        tedious, but LLMs excel at mapping API specifications and documentation
        to a predefined framework. Leverage our AI-powered tooling to accelerate
        your connectors roadmap by 10x.'
        />
        <SolutionCompanies subtitle='World-class data integration platforms build their connectivity on top of Integration App' />
        <SolutionInfrastructure />
        <BestSupport
          isSolutionsSection
          subtitle={
            <>
              Integrations are hard and messy. <br /> Our success team will help
              you every step of the way.
            </>
          }
          className={classes.support}
        />
      </Container>
    </DefaultPageLayout>
  )
}
